/* eslint-disable react-refresh/only-export-components */
import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { RequireAuth } from '@/app/router/RequireAuth'

const LaddersPage = lazy(() => import('@/pages/ladders/Page').then((m) => ({ default: m.LaddersPage })))
const LadderDetailPage = lazy(() => import('@/pages/ladders/detail/Page').then((m) => ({ default: m.LadderDetailPage })))
const LadderNewRoutePage = lazy(() => import('@/pages/ladders/new/Page').then((m) => ({ default: m.LadderNewRoutePage })))
const LadderManageRoutePage = lazy(() => import('@/pages/ladders/manage/Page').then((m) => ({ default: m.LadderManageRoutePage })))

export function ladderRoutes() {
  return (
    <>
      <Route path="/ladders/:ladderId" element={<LadderDetailPage />} />
      <Route
        path="/ladders/:ladderId/manage"
        element={
          <RequireAuth requireRole="club_staff">
            <LadderManageRoutePage />
          </RequireAuth>
        }
      />
      <Route path="/ladders" element={<LaddersPage />} />
      <Route
        path="/ladders/new"
        element={
          <RequireAuth requireRole="club_staff">
            <LadderNewRoutePage />
          </RequireAuth>
        }
      />
    </>
  )
}
